import React, { useState, useEffect, useRef } from 'react'

import Score from './Score'
import GiveUpButton from './GiveUpButton'
import github from '../Resources/github.png'

import './QuizFooter.css'

const QuizFooter = ({ score, max, onGiveUp, gaveUp, showGiveUp }) => {
  const [footerVisible, setVisible] = useState(false)
  const footerRef = useRef(null)

  useEffect(() => {
    const checkFooterVisibility = () => {
      if (!footerRef.current) return

      const top = footerRef.current.getBoundingClientRect().top
      setVisible(top + 47 <= window.innerHeight)
    }

    checkFooterVisibility()
    window.addEventListener('scroll', checkFooterVisibility)
    window.addEventListener('resize', checkFooterVisibility)

    return () => {
      window.removeEventListener('scroll', checkFooterVisibility)
      window.removeEventListener('resize', checkFooterVisibility)
    }
  }, [])

  return (
    <div className='Quiz-footer' ref={footerRef}>
			{showGiveUp && (
      	<GiveUpButton onClick={onGiveUp} isDisabled={gaveUp} />
			)}
      <Score score={score} max={max} fixed />
      <div className='Quiz-footer-text'>
      </div>
    </div>
  )
}

export default QuizFooter
